export default "__VITE_ASSET__DnZ0Gnjg__"